import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { loadUser } from "./redux/userSlice";
import { HelmetProvider } from "react-helmet-async";

// import Navbar from "./componets/Layout/Navbar";
import ProtectedRoute from "./componets/private_routes/ProtectedRoute";
import PublicRoute from "./componets/private_routes/PublicRoute";
import LoginPage from "./componets/Layout/LoginPage";

import Home from "./componets/Routes_pages/Users";
import Process from "./componets/Routes_pages/Process";
import Party from "./componets/Routes_pages/Party";
import Emp from "./componets/Routes_pages/Emp";
import EmpWork from "./componets/Routes_pages/EmpWork";
import Payment from "./componets/Routes_pages/Payment";
import Bill from "./componets/Routes_pages/Bill";
import BillReport from "./componets/Routes_pages/BillReport";
import EmpReport from "./componets/Routes_pages/EmpReport";
import DailyWorkEntry from "./componets/Routes_pages/DailyWorkEntry";
import WorkReport from "./componets/Routes_pages/WorkReport";
import OutstandingPayments from "./componets/Routes_pages/OutstandingPayments";


function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadUser());
  }, [dispatch]);

  return (
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
        {/* Public Route - Login (only accessible when not authenticated) */}
        <Route
          path="/login"
          element={
            <PublicRoute>
              <LoginPage />
            </PublicRoute>
          }
        />

        {/* Protected Routes - All pages require authentication */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />
        <Route
          path="/process"
          element={
            <ProtectedRoute>
              <Process />
            </ProtectedRoute>
          }
        />
        <Route
          path="/party"
          element={
            <ProtectedRoute>
              <Party />
            </ProtectedRoute>
          }
        />
        <Route
          path="/emp"
          element={
            <ProtectedRoute>
              <Emp />
            </ProtectedRoute>
          }
        />
        <Route
          path="/empwork"
          element={
            <ProtectedRoute>
              <EmpWork />
            </ProtectedRoute>
          }
        />
        <Route
          path="/payment"
          element={
            <ProtectedRoute>
              <Payment />
            </ProtectedRoute>
          }
        />
        <Route
          path="/bill"
          element={
            <ProtectedRoute>
              <Bill />
            </ProtectedRoute>
          }
        />
        <Route
          path="/bill-report"
          element={
            <ProtectedRoute>
              <BillReport />
            </ProtectedRoute>
          }
        />
        <Route
          path="/emp-report"
          element={
            <ProtectedRoute>
              <EmpReport />
            </ProtectedRoute>
          }
        />
        <Route
          path="/daily-work-entry"
          element={
            <ProtectedRoute>
              <DailyWorkEntry />
            </ProtectedRoute>
          }
        />
        <Route
          path="/work-report"
          element={
            <ProtectedRoute>
              <WorkReport />
            </ProtectedRoute>
          }
        />
        <Route
          path="/outstanding-payments"
          element={
            <ProtectedRoute>
              <OutstandingPayments />
            </ProtectedRoute>
          }
        />

        {/* Redirect any unknown routes to home */}
        <Route
          path="*"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
